<template>
    <v-container v-if="isAdminOrCompanyCoordinator" fluid class="px-10">
        <h1 class="mb-5 import-title">Imports </h1>
        <div class="import-container">
            <v-card class="upload-card">
                <v-card-title>
                    <v-icon class="mr-2" color="#0047AB">mdi-clipboard-arrow-down-outline</v-icon>Αναθέσεις (Παγώνης)
                </v-card-title>
                <v-card-subtitle>
                    Το αρχείο Excel του Παγώνη αυτούσιο.
                </v-card-subtitle>
                <v-file-input
                    v-model="assignmentsFile"
                    accept="text/xlsx, .xlsx"
                    placeholder="Επιλογή Excel Αναθέσεων"
                    label="Επιλογή Excel Αναθέσεων"
                    prepend-icon=""
                >
                    <template v-slot:selection="{ text }">
                        <v-chip
                            small
                            label
                            color="primary"
                        >
                            {{ text }}
                        </v-chip>
                    </template>
                    <template v-slot:prepend-inner>
                        <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-paperclip</v-icon>
                    </template>
                </v-file-input>
                <div class="import-button-wrapper">
                    <v-btn
                        class="mx-2 white--text"
                        large
                        color="black"
                        :disabled="!assignmentsFile"
                        :loading="assignmentsFile && loading"
                        @click="uploadAssignmentsFile"
                    >
                        Import
                    </v-btn>
                </div>
            </v-card>
            <v-card class="upload-card">
                <v-card-title>
                    <v-icon class="mr-2" color="#0047AB">mdi-clipboard-arrow-down-outline</v-icon>Βλάβες(FSM)
                </v-card-title>
                <v-card-subtitle>
                    Το αρχείο Excel βλαβών από FSM αυτούσιο.
                </v-card-subtitle>
                <v-file-input
                    v-model="malfunctionsFile"
                    accept="text/xlsx, .xlsx"
                    placeholder="Επιλογή Excel FSM Βλαβών"
                    label="Επιλογή Excel FSM Βλαβών"
                    prepend-icon=""
                >
                    <template v-slot:selection="{ text }">
                        <v-chip
                            small
                            label
                            color="primary"
                        >
                            {{ text }}
                        </v-chip>
                    </template>
                    <template v-slot:prepend-inner>
                        <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-paperclip</v-icon>
                    </template>
                </v-file-input>
                <div class="import-button-wrapper">
                    <v-btn
                        class="mx-2 white--text"
                        large
                        color="black"
                        :disabled="!malfunctionsFile"
                        :loading="malfunctionsFile && loading"
                        @click="uploadMalfunctionsFile"
                    >
                        Import
                    </v-btn>
                </div>
            </v-card>
            <v-card class="upload-card">
                <v-card-title>
                    <v-icon class="mr-2" color="orange">mdi-earth</v-icon>Περιοχές
                </v-card-title>
                <v-card-subtitle>
                    Aρχείο CSV με 1 στήλη με ονόματα περιοχών χωρίς επικεφαλίδα
                </v-card-subtitle>
                <v-file-input
                    v-model="locationFile"
                    accept="text/csv, .csv"
                    placeholder="Επιλογή CSV Περιοχών"
                    label="Επιλογή CSV Περιοχών"
                    prepend-icon=""
                >
                    <template v-slot:selection="{ text }">
                        <v-chip
                            small
                            label
                            color="primary"
                        >
                            {{ text }}
                        </v-chip>
                    </template>
                    <template v-slot:prepend-inner>
                        <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-paperclip</v-icon>
                    </template>
                </v-file-input>
                <div class="import-button-wrapper">
                    <v-btn
                        class="mx-2 white--text"
                        large
                        color="black"
                        :disabled="!locationFile"
                        :loading="locationFile && loading"
                        @click="uploadLocationFile"
                    >
                        Import
                    </v-btn>
                </div>
            </v-card>
            <v-card v-if="config.hasCabins" class="upload-card">
                <v-card-title>
                    <v-icon class="mr-2" color="#A47DAB">mdi-file-cabinet</v-icon>Καμπίνες
                </v-card-title>
                <v-card-subtitle>
                    Το αρχείο Excel καμπινών αυτούσιο.
                </v-card-subtitle>
                <v-select
                    v-model="selectedCabinClientId"
                    :items="clients"
                    item-value="id"
                    item-text="name"
                    label="Πελάτης"
                    clearable
                    outlined
                    class="field"
                    hide-details
                >
                    <template v-slot:selection="data">
                        <span class="font-weight-bold">{{ data.item.name }}</span>
                    </template>
                </v-select>
                <v-file-input
                    v-model="cabinsFile"
                    accept="text/xlsx, .xlsx"
                    placeholder="Επιλογή Excel Καμπίνων"
                    label="Επιλογή Excel Καμπίνων"
                    prepend-icon=""
                >
                    <template v-slot:selection="{ text }">
                        <v-chip
                            small
                            label
                            color="primary"
                        >
                            {{ text }}
                        </v-chip>
                    </template>
                    <template v-slot:prepend-inner>
                        <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-paperclip</v-icon>
                    </template>
                </v-file-input>
                <div class="import-button-wrapper">
                    <v-btn
                        class="mx-2 white--text"
                        large
                        color="black"
                        :disabled="!cabinsFile || !this.selectedCabinClientId"
                        :loading="cabinsFile && loading"
                        @click="uploadCabinFile"
                    >
                        Import
                    </v-btn>
                </div>
            </v-card>
            <v-card v-if="hasBackOfficeBilled" class="upload-card">
                <v-card-title>
                    <v-icon color="blue" class="mr-2">mdi-timeline-check-outline</v-icon>Back Office Τιμολογήσεις
                </v-card-title>
                <v-card-subtitle>
                    Aρχείο CSV με 1 στήλη με SRs χωρίς επικεφαλίδα
                </v-card-subtitle>
                <v-file-input
                    v-model="billingBackOfficeFile"
                    accept="text/csv, .csv"
                    placeholder="Επιλογή CSV SRs"
                    label="Επιλογή CSV SRs"
                    prepend-icon=""
                >
                    <template v-slot:selection="{ text }">
                        <v-chip
                            small
                            label
                            color="primary"
                        >
                            {{ text }}
                        </v-chip>
                    </template>
                    <template v-slot:prepend-inner>
                        <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-paperclip</v-icon>
                    </template>
                </v-file-input>
                <div class="import-button-wrapper">
                    <v-btn
                        class="mx-2 white--text"
                        large
                        color="black"
                        :disabled="!billingBackOfficeFile"
                        :loading="billingBackOfficeFile && loading"
                        @click="uploadBillingBackOfficeFile"
                    >
                        Import
                    </v-btn>
                </div>
            </v-card>
            <v-card v-if="config.hasStorage" class="upload-card">
                <v-card-title>
                    <v-icon class="mr-2" color="#9F2B68">mdi-warehouse</v-icon>Υλικά
                </v-card-title>
                <v-select
                    v-model="selectedMaterialClientId"
                    :items="clients"
                    item-value="id"
                    item-text="name"
                    label="Πάροχος"
                    clearable
                    outlined
                    class="field"
                    hide-details
                >
                    <template v-slot:selection="data">
                        <span class="font-weight-bold">{{ data.item.name }}</span>
                    </template>
                </v-select>
                <v-select
                    v-model="selectedMaterialTab"
                    :items="availableMaterialTabs"
                    item-value="value"
                    item-text="name"
                    label="Στάδιο"
                    clearable
                    outlined
                    class="field mt-3"
                    hide-details
                >
                    <template v-slot:selection="data">
                        <span class="font-weight-bold">{{ data.item.name }}</span>
                    </template>
                </v-select>
                <v-file-input
                    v-model="materialsFile"
                    accept="text/csv, .csv"
                    placeholder="Επιλογή CSV Υλικών"
                    label="Επιλογή CSV Υλικών"
                    prepend-icon=""
                >
                    <template v-slot:selection="{ text }">
                        <v-chip
                            small
                            label
                            color="primary"
                        >
                            {{ text }}
                        </v-chip>
                    </template>
                    <template v-slot:prepend-inner>
                        <v-icon :color="theming.cardsAndTablesText || 'black'">mdi-paperclip</v-icon>
                    </template>
                </v-file-input>
                <div class="import-button-wrapper">
                    <v-btn
                        class="mx-2 white--text"
                        large
                        color="black"
                        :disabled="!materialsFile"
                        :loading="materialsFile && loading"
                        @click="uploadMaterialsFile"
                    >
                        Import
                    </v-btn>
                </div>
            </v-card>
        </div>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-container>
</template>
<script>
    import jwtUtil from '@/utils/jwtUtil'
    import locationService from '@/services/location'
    import cabinService from '@/services/cabin'
    import clientService from '@/services/client'
    import materialService from '@/services/material'
    import assignmentService from '@/services/assignment'
    import backOfficeService from '@/services/backOffice'
    import Alert from '@/components/Alert'
    // import fileUtil from '@/utils/file'
    const COMPANY_NAME = process.env.VUE_APP_ENV_COMPANY_NAME

    export default {
        components: { Alert },
        data() {
            return {
                clients: [],
                locationFile: null,
                cabinsFile: null,
                billingBackOfficeFile: null,
                materialsFile: null,
                selectedCabinClientId: null,
                selectedMaterialTab: null,
                selectedMaterialClientId: null,
                assignmentsFile: null,
                malfunctionsFile: null,
                showAlert: false,
                message: null,
                type: null,
                loading: false
            }
        },
        computed: {
            theming() {
                return this.$store.getters.getTheming || {}
            },
            config() {
                return this.$store.getters.getConfig || {}
            },
            hasBackOfficeBilled() {
                return this.config?.backOffice?.steps?.some(step => step.value === 'billed')
            },
            availableMaterialTabs() {
                return Object.values(this.config.stagesPerAssignmentType)
                    .flat()
                    .reduce((acc, item) => {
                        if (!acc.some(x => x.value === item.value) && !['assignment', 'autopsy', 'backOffice'].includes(item.value)) {
                            acc.push(item)
                        }
                        return acc
                    }, [])
            },
            userRoles() {
                return jwtUtil.getRoles(this.$store.getters.getToken)
            },
            isAdminOrCompanyCoordinator() {
                return this.containsAny(['ROLE_ADMIN'], this.userRoles) || (this.containsAny(['ROLE_COORDINATOR'], this.userRoles) && this.userContractor.toLowerCase() === COMPANY_NAME.toLowerCase())
            },
            userContractor() {
                return this.$store.getters.getUserContractor || ''
            }
        },
        created() {
            this.getClients()
        },
        methods: {
            getClients() {
                clientService.getAllClients().then(resp => {
                    this.clients = resp.data
                    if (this.clients.length === 1) {
                        this.selectedCabinClientId = this.clients[0].id
                    }
                })
            },
            containsAny(arr1, arr2) {
                return arr1.some(item => arr2.includes(item))
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            uploadLocationFile() {
                this.loading = true
                let formData = new FormData()
                formData.append('file', this.locationFile)
                locationService.import(formData).then(resp => {
                    this.locationFile = null
                    this.setAlert('Οι περιοχές ανέβηκαν επιτυχώς', 'success')
                    this.loading = false
                }).catch((error) => {
                    this.setAlert(error.response.data.message, 'error')
                    this.loading = false
                })
            },
            uploadPagonisInfoFile() {
                if (!this.pagonisInfoFile) {
                    return
                }
                this.loading = true
                let formData = new FormData()
                formData.append('file', this.pagonisInfoFile)
                assignmentService.createPagonisInfoFile(formData).then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'pagonis-assignment-info.xlsx')
                    document.body.appendChild(link)
                    link.click()
                }).catch((error) => {
                    this.setAlert(error.response.data.message, 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            uploadBillingBackOfficeFile() {
                if (!this.billingBackOfficeFile) {
                    return
                }
                this.loading = true
                let formData = new FormData()
                formData.append('file', this.billingBackOfficeFile)
                backOfficeService.importBilling(formData).then(resp => {
                    this.billingBackOfficeFile = null
                    this.setAlert('Οι τιμολογήσεις ανέβηκαν επιτυχώς', 'success')
                }).catch((error) => {
                    if (error.response.data.code === 'INVALID_CONFIG') {
                        this.setAlert('Δεν βρέθηκε έγκυρη ρύθμιση για τιμολόγηση στο Back Office', 'error')
                    } else if (error.response.data.code === 'ASSIGNMENT_NOT_FOUND') {
                        this.setAlert('Οι αναθέσεις: ' + error.response.data.message + ' δεν βρέθηκαν στο σύστημα', 'error')
                    } else if (error.response.data.code === 'EMPTY_FILE') {
                        this.setAlert('Το αρχείο είναι κενό', 'error')
                    } else {
                        this.setAlert(error.response.data.message, 'error')
                    }
                }).finally(() => {
                    this.loading = false
                })
            },
            uploadCabinFile() {
                if (!this.selectedCabinClientId) {
                    return
                }
                this.loading = true
                let formData = new FormData()
                formData.append('file', this.cabinsFile)
                cabinService.import(this.selectedCabinClientId, formData).then(resp => {
                    this.cabinsFile = null
                    this.setAlert('Οι καμπίνες ανέβηκαν επιτυχώς', 'success')
                }).catch((error) => {
                    this.setAlert(error.response.data.message, 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            uploadMaterialsFile() {
                if (!this.materialsFile) {
                    return
                }
                this.loading = true
                let formData = new FormData()
                formData.append('file', this.materialsFile)
                materialService.import(this.selectedMaterialClientId, this.selectedMaterialTab, formData).then(resp => {
                    this.materialsFile = null
                    this.setAlert('Τα Υλικά ανέβηκαν επιτυχώς', 'success')
                }).catch((error) => {
                    this.setAlert(error.response.data.message, 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            uploadAssignmentsFile() {
                this.loading = true
                let formData = new FormData()
                formData.append('file', this.assignmentsFile)
                assignmentService.import(formData).then(resp => {
                    this.assignmentsFile = null
                    this.setAlert('Οι αναθέσεις ανέβηκαν επιτυχώς', 'success')
                }).catch((error) => {
                    this.setAlert(error.response.data.message, 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            uploadMalfunctionsFile() {
                this.loading = true
                let formData = new FormData()
                formData.append('file', this.malfunctionsFile)
                assignmentService.importFsmMalfunctions(formData).then(resp => {
                    this.malfunctionsFile = null
                    this.setAlert('Οι βλάβες ανέβηκαν επιτυχώς', 'success')
                }).catch((error) => {
                    this.setAlert(error.response.data.message, 'error')
                }).finally(() => {
                    this.loading = false
                })
            }
        }
    }
</script>
<style scoped>
.import-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
}
.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.upload-card {
    width: 350px;
    margin: 1rem;
    padding: 1rem;
    background: var(--cards-and-tables-color);
    color: var(--cards-and-tables-text-color);
    display: flex;
    flex-direction: column;
}

.import-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
}
.import-title {
    color: var(--cards-and-tables-text-color);
}
</style>
